import React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import styles from "../OrderhistoryCard/OrderhistoryCard.module.scss";
import EditIcon from "../../Assets/images/edit.svg";
import { PAYMENT_METHODS } from "Helpers/Constants";

export default function PaymentHistoryCard(props) {
  return (
    <Card className={` ${styles.OrderHistoryCard} ${styles.default}`}>
      <CardContent className={`${styles.content}`}>
        <div className="d-flex justify-content-between">
          <p className={`${styles.CustomerName}`}>
            {props.data.name_on_card ?? "-"}
          </p>
        </div>
        <div className={`d-flex justify-content-between mt-4`}>
          <p className={`${styles.OrderId}`}>
            xxxx xxxx xxxx {props.data.last_4number ?? "xxxx"}
          </p>
          <p className={`${styles.OrderPrice}`} style={{ fontSize: "18px" }}>
            {props.data.card_type ?? ""}
          </p>
        </div>
      </CardContent>
    </Card>
  );
}
